<template>
    <div class="col-md-12 bg-violet text-white p-lg-6" style="font-size: 16px">

        <div class="col-md-12 row pb-4 justify-content-end mt-4">
            <div class="col-md-6">
                <img :src="publicPath + 'media/logo-svg.svg'" class="logo-edutalk" alt="Edutalk Tư Vấn"
                     aria-roledescription="logo" style="height: 100px; margin-top: -40px; margin-left: -50px" >
            </div>
            <div class="col-md-6 row">
                <div class="col-md-4">
                    <el-select clearable v-model="query.user_ids" filterable multiple class="w-100"
                               placeholder="Chọn RSM" @change="getData">
                        <el-option
                            v-for="item in users"
                            :key="item.id"
                            :label="item.name"
                            placeholder="Chọn RSM"
                            :value="item.id">
                            <span style="float: left">{{ item.name }}</span>
                        </el-option>
                    </el-select>
                </div>
                <div class="col-md-4">
                    <el-select clearable v-model="query.area_id" filterable class="w-100"
                               placeholder="Chọn khu vực" @change="changeArea">
                        <el-option
                            v-for="item in areas"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                            <span style="float: left">{{ item.name }}</span>
                        </el-option>
                    </el-select>
                </div>
                <div class="col-md-4">
                    <el-select clearable v-model="query.months" multiple filterable class="w-100"
                               placeholder="Chọn tháng" @change="getData">
                        <el-option
                            v-for="item in months"
                            :key="item"
                            :label="`Tháng `+ item"
                            :value="item">
                            <span style="float: left"> Tháng {{ item }}</span>
                        </el-option>
                    </el-select>
                </div>
            </div>
        </div>
        <div class="row" style="display: flex; gap: 20px; justify-content: space-between">
            <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 col-12 custom-background">
                <h2>Doanh số đội nhóm</h2>
                <h1 style="font-size: 30px">{{ totalAllAmount | formatVND }}</h1>
                <h2>
                    <span class="text-success">{{ percent }}% </span>
                    <span>so với chỉ tiêu doanh số</span>
                </h2>
                <canvas :ref="'chart-table'" width="200" height="30"></canvas>
            </div>
            <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 col-12 custom-background custom-text-center">
                <div class="content">
                    <label style="font-size: 22px">Chỉ tiêu</label>
                    <h1 class="mt-2" style="font-size: 30px">{{ totalTarget | formatVND }}</h1>
                </div>
            </div>
            <div class="col-xl-2 col-lg-6 col-md-6 col-sm-12 col-12 custom-background custom-text-center">
                <div class="content">
                    <label style="font-size: 22px">Số văn phòng</label>
                    <h1 class="mt-2" style="font-size: 30px">{{ totalBranches }}</h1>
                </div>
            </div>
            <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 col-12 custom-background custom-text-center">
                <div class="content">
                    <label style="font-size: 22px">Trung bình chỉ tiêu / Văn phòng</label>
                    <h1 class="mt-2" style="font-size: 30px">{{ totalTarget / totalBranches | formatVND }}</h1>
                </div>
            </div>
        </div>
        <div class="row d-xl-flex p-lg-0 mt-6 justify-content-between">
            <div class="col-xl-6 col-lg-5 col-md-12 col-12 rounded p-4 background-linear mb-3">
                <h2 style="color: black!important;">PHỤ TRÁCH VÙNG RSM</h2>
                <div class="table-responsive">
                    <table class="table table-report w-100 text-left rounded" style="font-size: 18px">
                        <thead class="custom-thead">
                            <tr>
                                <th></th>
                                <th></th>
                                <th>Doanh thu</th>
                                <th class="text-left">Doanh thu / Chỉ tiêu</th>
                                <th >% Đạt doanh thu</th>
                            </tr>
                        </thead>
                        <tbody class="custom-tbody">
                            <tr v-for="(item, index) in salesData" :key="index" @click="changeDataRSM(item.id)">
                                <td>{{ index + 1 }} .</td>
                                <td>{{ item.user ? item.user.name : '' }}</td>
                                <td>{{ item.totalAmount |formatVND }}</td>
                                <td>
                                    <canvas :ref="'chart-table1' + index" width="200" height="30"></canvas>
                                </td>
                                <td class="text-center">{{ item.percent }} %</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="col-xl-6 col-lg-5 col-md-12 col-12">
                <div class="rounded p-4 background-linear" >
                    <h2 style="color: black!important;">BÁO CÁO DOANH THU THEO KHU VỰC</h2>
                    <div class="table-responsive">
                        <table class="table table-report w-100 text-left rounded">
                        <thead class="custom-thead">
                            <tr>
                                <th>Khu vực</th>
                                <th>Số VP</th>
                                <th>Doanh thu</th>
                                <th class="text-left">Doanh thu / Chỉ tiêu</th>
                                <th class="text-center">% Đạt doanh thu</th>
                            </tr>
                        </thead>
                        <tbody class="custom-tbody">
                            <tr v-for="(item, index) in salesData2.areas" :key="index">
                                <td>{{ item.name }}</td>
                                <td>{{ salesData2.areas.length }}</td>
                                <td>{{ item.totalAmount |formatVND }}</td>
                                <td>
                                    <canvas :ref="'chart-table2' + index" width="200" height="30"></canvas>
                                </td>
                                <td class="text-center">{{ item.percent }} %</td>
                            </tr>
                        </tbody>
                    </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="row d-xl-flex p-lg-0 mt-4">
            <div class="col-12 mt-4 p-4 background-linear">
                <h2 style="color: black!important;">BÁO CÁO DOANH THU THEO VĂN PHÒNG</h2>
                <div class="table-responsive">
                    <table class="table table-report w-100 text-left rounded">
                    <thead class="custom-thead">
                        <tr>
                            <th>Khu vực</th>
                            <th>Văn phòng</th>
                            <th>GĐVP</th>
                            <th>Doanh thu</th>
                            <th class="text-left">Doanh thu / Chỉ tiêu</th>
                            <th class="text-center">% Đạt doanh thu</th>
                        </tr>
                    </thead>
                    <tbody class="custom-tbody">
                        <tr v-for="(item, index) in allBranches" :key="index">
                            <td>{{ item.area_name }}</td>
                            <td>{{ item.name_alias ?? item.name }}</td>
                            <td>{{ item.gdvp_name }}</td>
                            <td>{{ item.amount |formatVND }}</td>
                            <td>
                                <canvas :ref="'chart-table3' + index" width="200" height="30"></canvas>
                            </td>
                            <td class="text-center">{{ item.percent }} %</td>
                        </tr>
                    </tbody>
                </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    Chart as ChartJS,
    Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale,
} from 'chart.js'
import Chart from 'chart.js/auto';
import {REPORT_LIST_RSM, REPORT_RSM_DOANH_SO_DOI_NHOM} from "../../../core/services/store/report.module";
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

export default {
    // doanh số theo đội nhóm
    name: 'TeamSales',

    data() {
        return {
            data: [],
            salesData: [],
            originalSalesData2: [],
            salesData2: {
                areas: []
            },
            allBranches: [],
            totalTarget: 0,
            totalBranches: 0,
            totalAllAmount: 0,
            percent: 0,
            originalData: [],
            currentRSMId: null,
            chartInstances: new Map(),
            publicPath: process.env.VUE_APP_BASE_URL,
            users: [],
            query: {
                user_ids: [],
                area_id: '',
                months: []
            },
            areas: [],
            months: [1,2,3,4,5,6,7,8,9,10,11,12],
        }
    },
    mounted() {
        this.$store.dispatch(SET_BREADCRUMB, [
            {title: "Doanh số đội nhóm", icon: 'far fa-calendar-alt'}
        ]);
        this.getData();
        this.getUsers();
    },
    methods: {
        getData()
        {
            this.$store.dispatch(REPORT_RSM_DOANH_SO_DOI_NHOM, this.query).then((res) => {
                this.data = res.data;
                this.originalData = this.data;
                this.handleDataRSM();
            });
        },
        handleDataRSM()
        {
            let total = 0;
            let totalBranches = 0;
            let totalAllAmount = 0;

            this.salesData = this.data.map((item) => {
                let totalTarget = 0;
                let totalAmount = 0;


                item.areas.forEach(area => {
                    let areaTarget = 0;
                    let areaAmount = 0;

                    area.branches.forEach(branch => {
                        const target = parseFloat(branch.target || 0);
                        const amount = Number(branch.amount || 0);
                        areaTarget += target;
                        areaAmount += amount;
                        branch.percent = target > 0 ? Math.ceil((amount / target) * 100) : 0;
                        branch.area_name = area.name;
                        totalBranches++;
                        return branch;
                    });

                    area.totalTarget = areaTarget;
                    area.totalAmount = areaAmount;
                    area.percent = areaTarget > 0 ? Math.ceil((areaAmount / areaTarget) * 100) : 0;

                    totalTarget += areaTarget;
                    totalAmount += areaAmount;
                });

                item.totalTarget = totalTarget;
                item.totalAmount = totalAmount;
                total += totalTarget;
                totalAllAmount += totalAmount;
                item.percent = totalTarget > 0 ? Math.ceil((totalAmount / totalTarget) * 100) : 0;

                return item;
            });

            this.totalTarget = total;
            this.totalAllAmount = totalAllAmount;
            this.totalBranches = totalBranches;
            this.percent = total > 0 ? Math.ceil((totalAllAmount / total) * 100) : 0;
            this.allBranches = this.data.flatMap(item =>
                item.areas ? item.areas.flatMap(area => area.branches || []) : []
            );

            this.settingPrecent();
            this.$nextTick(() => {
                this.salesData.forEach((item, index) => {
                    const refKey = `chart-table1${index}`;
                    const canvas = this.$refs[refKey];
                    const ctx = Array.isArray(canvas) ? canvas[0] : canvas;
                    if (!ctx)
                    {
                        return;
                    }
                    const maxPercent = this.getMaxPercent(this.salesData);

                    if (this.chartInstances.has(canvas)) {
                        this.chartInstances.get(canvas).destroy();
                        this.chartInstances.delete(canvas);
                    }
                    const config = {
                        type: 'bar',
                        data: {
                            labels: [''],
                            datasets: [{
                                label: item.percent.toFixed(1) + '%',
                                data: [item.percent],
                                backgroundColor: '#b2f2bb',
                            }]
                        },
                        options: {
                            indexAxis: 'y',
                            responsive: false,
                            maintainAspectRatio: false,
                            scales: {
                                x: {
                                    display: true,
                                    min: 0,
                                    max: maxPercent,
                                    ticks: {
                                        stepSize: 100,
                                        color: '#000000',
                                        font: {
                                            size: 5,
                                            weight: 'bold'
                                        }
                                    },
                                    grid: {
                                        display: true,
                                        color: 'rgba(255,255,255,0.2)',
                                        tickColor: '#000000',
                                    }
                                },
                                y: {
                                    display: false,
                                    ticks: {
                                        color: '#000000',
                                    },
                                }
                            },
                            plugins: {
                                legend: { display: false },
                                tooltip: { enabled: false }
                            },

                        }
                    };

                    this.createOrUpdateChart(refKey, config);
                });
            });

            if (this.salesData[0])
            {
                this.salesData2 = this.salesData[0];
                if (!this.originalSalesData2.id)
                {
                    this.originalSalesData2 = JSON.parse(JSON.stringify(this.salesData2));

                    this.areas = this.originalSalesData2.areas;
                }

                this.settingSalesData2()
            }
            this.$nextTick(() => {
                setTimeout(() => {
                    this.settingAllBranches();
                }, 100);
            });
        },
        settingSalesData2() {

            this.$nextTick(() => {
                this.salesData2.areas.forEach((item, index) => {
                    const refKey = `chart-table2${index}`;
                    const canvas = this.$refs[refKey];
                    const ctx = Array.isArray(canvas) ? canvas[0] : canvas;
                    if (!ctx)
                    {
                        console.log(refKey, 'refKey');
                        return;
                    }
                    if (this.chartInstances.has(canvas)) {
                        this.chartInstances.get(canvas).destroy();
                    }

                    const maxPercent = this.getMaxPercent(this.salesData2.areas);

                    const config = {
                        type: 'bar',
                        data: {
                            labels: [''],
                            datasets: [{
                                label: item.percent.toFixed(1) + '%',
                                data: [item.percent],
                                backgroundColor: '#b2f2bb',
                            }]
                        },
                        options: {
                            indexAxis: 'y',
                            responsive: false,
                            maintainAspectRatio: false,
                            scales: {
                                x: {
                                    display: true,
                                    min: 0,
                                    max: maxPercent,
                                    ticks: {
                                        stepSize: 100,
                                        color: '#000000',
                                        font: {
                                            size: 5,
                                            weight: 'bold'
                                        }
                                    },
                                    grid: {
                                        display: true,
                                        color: 'rgba(255,255,255,0.2)',
                                        tickColor: '#000000',
                                    }
                                },
                                y: {
                                    display: false,
                                    ticks: {
                                        color: '#000000',
                                    },
                                }
                            },
                            plugins: {
                                legend: { display: false },
                                tooltip: { enabled: false }
                            }
                        }
                    };

                    this.createOrUpdateChart(refKey, config);
                });
            });
        },

        settingAllBranches() {
            this.$nextTick(() => {
                this.allBranches.forEach((item, index) => {
                    const refKey = `chart-table3${index}`;
                    const canvas = this.$refs[refKey];
                    const ctx = Array.isArray(canvas) ? canvas[0] : canvas;
                    if (!ctx)
                    {
                        return;
                    }
                    if (this.chartInstances.has(canvas)) {
                        this.chartInstances.get(canvas).destroy();
                        this.chartInstances.delete(canvas);
                    }

                    const maxPercent = this.getMaxPercent(this.allBranches);
                    const config = {
                        type: 'bar',
                        data: {
                            labels: [''],
                            datasets: [{
                                label: item.percent.toFixed(1) + '%',
                                data: [item.percent],
                                backgroundColor: '#b2f2bb',
                            }]
                        },
                        options: {
                            indexAxis: 'y',
                            responsive: false,
                            maintainAspectRatio: false,
                            scales: {
                                x: {
                                    display: true,
                                    min: 0,
                                    max: maxPercent,
                                    ticks: {
                                        stepSize: 100,
                                        color: '#000000',
                                        font: {
                                            size: 5,
                                            weight: 'bold'
                                        }
                                    },
                                    grid: {
                                        display: true,
                                        color: 'rgba(255,255,255,0.2)',
                                        tickColor: '#000000',
                                    },
                                },
                                y: {
                                    display: false,
                                    ticks: {
                                        color: '#000000',
                                    },
                                }
                            },
                            plugins: {
                                legend: { display: false },
                                tooltip: { enabled: false }
                            }
                        }
                    };

                    this.createOrUpdateChart(refKey, config);
                });
            });
        },
        getMaxPercent(data)
        {
            return Math.ceil(
                Math.max(...data.map(item => item.percent || 0), 100) / 100
            ) * 100;
        },
        changeDataRSM(id)
        {
            if (this.currentRSMId === id) {
                this.data = [...this.originalData];
                this.currentRSMId = null;
            } else {
                let found = this.originalData.find(item => item.id == id);
                if (found) {
                    this.data = [found];
                    this.currentRSMId = id;
                }
            }

            this.handleDataRSM();
        },
        createOrUpdateChart(refKey, chartConfig) {
            const canvas = this.$refs[refKey];
            const ctx = Array.isArray(canvas) ? canvas[0] : canvas;
            if (!ctx) return;

            if (this.chartInstances.has(refKey)) {
                this.chartInstances.get(refKey).destroy();
                this.chartInstances.delete(refKey);
            }

            const chart = new Chart(ctx, chartConfig);
            this.chartInstances.set(refKey, chart);
        },
        settingPrecent()
        {
            const refKey = `chart-table`;
            const canvas = this.$refs[refKey];
            const ctx = Array.isArray(canvas) ? canvas[0] : canvas;
            if (!ctx)
            {
                return;
            }
            const maxPercent = 100;
            if (this.chartInstances.has(canvas)) {
                this.chartInstances.get(canvas).destroy();
                this.chartInstances.delete(canvas);
            }
            const config = {
                type: 'bar',
                data: {
                    labels: [''],
                    datasets: [{
                        label: this.percent.toFixed(1) + '%',
                        data: [this.percent],
                        backgroundColor: '#b2f2bb',
                    }]
                },
                options: {
                    indexAxis: 'y',
                    responsive: false,
                    maintainAspectRatio: false,
                    scales: {
                        x: {
                            display: true,
                            min: 0,
                            max: maxPercent,
                            ticks: {
                                stepSize: 100,
                                color: '#fff',
                                font: {
                                    size: 5,
                                    weight: 'bold'
                                }
                            },
                            grid: {
                                display: true,
                                color: 'rgba(255,255,255,0.2)',
                            }
                        },
                        y: {
                            display: false
                        }
                    },
                    plugins: {
                        legend: { display: false },
                        tooltip: { enabled: false }
                    }
                }
            };
            this.createOrUpdateChart(refKey, config);

        },
        getUsers()
        {
            this.$store.dispatch(REPORT_LIST_RSM, {}).then((res) => {
                this.users = res.data;
            });
        },
        changeArea()
        {
            if (!this.query.area_id)
            {
                this.salesData2.areas = JSON.parse(JSON.stringify(this.originalSalesData2.areas));
                return;
            }
            this.salesData2.areas = this.originalSalesData2.areas.filter(item => item.id == this.query.area_id);
            this.allBranches = this.allBranches.filter(item => item.area_id == this.query.area_id);
        }
    }
}
</script>

<style scoped>
    canvas {
        width: 100%;
        height: 30px !important;
        border-radius: 4px;
    }
    .bg-violet {
        background-color: rgb(47, 28, 74);
    }
    .background-linear {
        background: rgba(255, 255, 255, 0.9)!important;
        border-radius: 15px!important;
    }
    .table thead th {
        border-bottom: unset;
    }
    .table-config {
        background: linear-gradient(135deg, rgb(130, 48, 206) 0%, rgb(80, 54, 148) 100%);
        box-shadow: rgba(0, 0, 0, 0.3) 0px 1px 2px 0px, rgba(0, 0, 0, 0.15) 0px 1px 3px 1px;
    }
    .custom-background {
        background: rgb(91 63 131)!important;
        border-radius: 15px;
        padding: 20px;

    }
    .custom-text-center {
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
    }
    .custom-thead {
        background: rgba(139, 92, 246, 0.05);
    }
    .custom-tbody {
        background: white;
        color: black!important;
    }
    .table tbody tr:hover {
        background: rgba(102, 51, 153, 0.3);
    }
</style>
